import { ITextAreaStyle } from "../../../../base/domain/drawing";
import {
  IFontSizeAutoAdjustBehavior,
  ILineBreakBehaviorSpecifiable, instanceOfILineBreakBehaviorSpecifiable
} from "../../../../documaker/domain/format/objects";
import { instanceOfIRectangleCoordinatableObject, IRectangleCoordinatableObject } from "./IRectangleCoordinatableObject";

export interface IDateTextDrawableObject extends IRectangleCoordinatableObject, ILineBreakBehaviorSpecifiable {
  textStyle: ITextAreaStyle;
  fontSizeAutoAdjustBehavior: IFontSizeAutoAdjustBehavior;
}

export function instanceOfIDateTextDrawableObject<T extends IDateTextDrawableObject>(instance: any): instance is IDateTextDrawableObject {
  return instance
      && instance.textStyle
      && instance.fontSizeAutoAdjustBehavior
      && instanceOfILineBreakBehaviorSpecifiable(instance)
      && instanceOfIRectangleCoordinatableObject<T>(instance, "date");
}
